export default "__VITE_ASSET__BuB0ZEZ___"